
import EventAPI from '../../api/EventAPI';
import PlaceAPI from '../../api/PlaceAPI'
import Layout from '../../components/Layout'
import { getIdMatch, canoc } from '../../managers/Utils'
import SearchResultItems from '../../components/SearchResultItems';
import { useEffect, useState } from 'react'

const placeApi = new PlaceAPI();
const eventApi = new EventAPI();

async function getEvents(place, zoneSlug) { 
    const placeEvents = await eventApi.getUpcomingEvents(zoneSlug, {venueId: place.id})
    if (placeEvents && placeEvents.code !== -1) { 
        return placeEvents
    } else { 
        return null;
    }
}

const PlaceView = (props: any) => { 

    // const [events, setEvents] = useState([])


    // async function loadEvents() { 
    //     const events = await getEvents(props.place);
    //     setEvents(events);
    // }

    useEffect(() => { 
        console.log(props.place)
        // loadEvents();
    }, [])

    return <Layout title={`${props.place.name} Upcoming hip hop, afrobeat, and black events - ETA`} description={`See upcoming hip hop, afrobeat and black events at ${props.place.name} curated by the culture for the culture.`} imageUrl={props.place.image_url} 
    canoncialUrl={canoc(props.place.name, props.place.id)}>
        
        <div id="placeInfo" style={{marginBottom: 20, marginTop: 40, textAlign: 'center'}}>
            <img src={props.place.image_url}  style={{marginBottom: 20, objectFit:'cover', borderRadius: '100px', border: '10px solid lightgray'}} height="200px" width="200px" />
            <h1 style={{textAlign: 'center'}}>{props.place.name}</h1>
            <p>{props.place.address}</p>
            <p><a href={props.place.link} style={{color: 'black', textDecoration: 'underline'}}>Website</a></p>
        </div>

        <div id="eventsList" style={{marginTop: 40}}>
            <h3 style={{marginBottom: 20}}>Upcoming events</h3>
            {props.events.map((event) => <SearchResultItems userAgent={props.userAgent} eventData={event} key={event.id} onClick={() => window.location.href = `/event/${canoc(event.title, event.id)}`}/>

            )}
        </div>

    </Layout>
}

PlaceView.getInitialProps = async (ctx: any) => { 
    const placeId = getIdMatch(ctx.query.placeId);
    const zoneSlug = ctx.query.zone;
    if (!placeId) {
        ctx.res.redirect('/404')
    } 
    const place = await placeApi.getPlaces({placeId: placeId});
    if (!place) {
        ctx.res.redirect('/404')
    } 
    const events = await getEvents(place, zoneSlug);
    return { place: place, events: events }
}

export default PlaceView;